module.exports = {
	"schools": {
		"-KzOPJEzp8YzJUUz8c38": {
			"district": "####################",
			"state": "####################",
			"settings_code": "####################",
			"logo_url": "https://firebasestorage.googleapis.com/v0/b/launchpad-169908.appspot.com/o/%23%23%23%23%23%23%23%23%23%23.png?alt=media&token=f9bbd2d5-d7a9-4cb5-893b-9c7ab1d7999a",
			"logo_url_thumbnail": "https://firebasestorage.googleapis.com/v0/b/launchpad-169908.appspot.com/o/%23%23%23%23%23%23%23%23%23%23.png?alt=media&token=f9bbd2d5-d7a9-4cb5-893b-9c7ab1d7999a",
			"android_enabled": false,
			"ios_enabled": false,
			"status_bar_logout": false,
			"background": false,
			"tms": false,
			"completed": false,
			"disable_custom_user_agent": false,
			"coordinates": {
				"latitude": 0,
				"longitude": 0
			}
		}
	},
	"notes": {
		"-Mr8y5IpQRW5_K4jWF_b": {
			"api": "",
			"enabled": false,
			"message": "message",
			"version": 0
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/schema.json
// module id = 819
// module chunks = 0